import { CustomComponentItemType, CustomComponentItemWithPathType, SideNavItem } from './types';

export const getCustomisationEntityAri = (cloudId?: string, activationId?: string | null) =>
  cloudId && activationId && `ari:cloud:townsquare:${cloudId}:workspace/${activationId}`;

export const isCustomComponentItemType = (item: SideNavItem): item is CustomComponentItemType => {
  return 'Component' in item && typeof item.Component === 'function' && !('path' in item);
};

export const isCustomComponentItemWithPathType = (item: SideNavItem): item is CustomComponentItemWithPathType => {
  return 'Component' in item && typeof item.Component === 'function' && 'path' in item && typeof item.path === 'string';
};
